import PropTypes from 'prop-types';
import { ExportReportOptionsModal } from '../../modals/ExportReportOptionsModal/ExportReportOptionsModal';
import { TableExportIcon } from '../../icons/analytics';
import { PopupToggler } from '../../blocks/PopupToggler';

export function ExportReportPopupToggler({ onExport, disabled }) {
  return (
    <PopupToggler
      icon={
        <>
          <TableExportIcon />
          Export data
        </>
      }
      wide
      disabled={disabled}
      hideCaret
    >
      {(closePopup) => <ExportReportOptionsModal onExport={onExport} onClose={closePopup} />}
    </PopupToggler>
  );
}

ExportReportPopupToggler.propTypes = {
  onExport: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
